module.exports = __webpack_public_path__ + "img/94.c3a20a70.jpg";